import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'socicon/css/socicon.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './_metronic/_assets/plugins/line-awesome/css/line-awesome.css';
import './_metronic/_assets/plugins/flaticon/flaticon.css';
import './_metronic/_assets/plugins/flaticon2/flaticon.css';
import 'react-toastify/dist/ReactToastify.css';
import 'static/css/index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

import App from './App';

Sentry.init({
  dsn:
    'https://813f9a21468712e5a261d3a2407fdd86@o4511435407032320.ingest.us.sentry.io/4511435420336128',
  sendDefaultPii: false,
});

// Safari throws NotFoundError when React insertBefore/removeChild runs after a
// third-party script (Tealium, Securiti, Crisp) has moved the node. Swallowing
// that mismatch keeps the whole tree from unmounting to a blank page.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

if (!document.getElementById('chat-placeholder-root')) {
  const chatPlaceholderRoot = document.createElement('div');
  chatPlaceholderRoot.id = 'chat-placeholder-root';
  document.body.appendChild(chatPlaceholderRoot);
}

ReactDOM.render(<App />, document.getElementById('root'));
